import React from "react";
import { useLang } from "../lib/lang-context";
import { LOGO_URL } from "../lib/i18n";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-black text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid opacity-30" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <img
              src={LOGO_URL}
              alt="ICOR"
              className="h-16 w-auto"
              style={{
                mixBlendMode: "screen",
                filter: "brightness(2.4) contrast(1.05)",
              }}
            />
            <p className="mt-6 text-white/60 leading-relaxed max-w-sm">
              {t.footer.tagline}
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-10">
            <FooterCol title={t.footer.sections.company}>
              <FooterLink href="#about">{t.footer.links.about}</FooterLink>
              <FooterLink href="#contact">{t.footer.links.contact}</FooterLink>
            </FooterCol>
            <FooterCol title={t.footer.sections.products}>
              <FooterLink href="#products">{t.nav.products}</FooterLink>
              <FooterLink href="#quote">{t.footer.links.quote}</FooterLink>
            </FooterCol>
            <FooterCol title={t.footer.sections.legal}>
              <FooterLink href="#">{t.footer.links.privacy}</FooterLink>
              <FooterLink href="#">{t.footer.links.terms}</FooterLink>
            </FooterCol>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {year} ICOR. {t.footer.rights}
          </p>
          <div className="flex items-center gap-5 text-xs">
            <a
              href="/admin/login"
              data-testid="footer-admin-link"
              className="text-white/40 hover:text-white tracking-[0.18em] uppercase transition-colors"
            >
              Portal interno
            </a>
            <p className="text-white/40 tracking-[0.18em] uppercase">
              Hecho en México
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

const FooterCol = ({ title, children }) => (
  <div>
    <div className="text-xs uppercase tracking-[0.2em] font-semibold text-white/50 mb-4">
      {title}
    </div>
    <ul className="flex flex-col gap-3">{children}</ul>
  </div>
);

const FooterLink = ({ href, children }) => (
  <li>
    <a
      href={href}
      className="text-sm text-white/80 hover:text-white transition-colors"
    >
      {children}
    </a>
  </li>
);
